import { get } from 'lodash';
import React from 'react';
import { useMealPlanDiscount } from 'src/pages/consumer/meal-plans/useMealPlanDiscount';
import { useCachedZipCode } from 'src/user-preferences/useCachedZipCode';
import { getFeaturedShefs, ShefTrio } from './ShefTrio';

export const SIGN_UP_MODAL_GATING_REGION_IDS = [5, 6, 7, 8, 9, 10];

interface LoginModalMealPlanHeaderProps {
  hideImages: boolean;
}

export const LoginModalMealPlanHeader: React.FC<LoginModalMealPlanHeaderProps> = ({ hideImages }) => {
  const { totaledDiscountText } = useMealPlanDiscount();
  const [, , cachedZipCodeMetaData] = useCachedZipCode();

  const zipCodeRegionId = get(cachedZipCodeMetaData, 'cachedZipCodeData.zipCode.region.id');
  const shefs = getFeaturedShefs(zipCodeRegionId);

  if (!shefs) return null;

  return (
    <div className='md:px-4'>
      <p className='mb-4 text-center text-h5-bold uppercase text-eggplant'>
        Claim <span className='text-mint-500'>{totaledDiscountText}</span> off and unlock your shef matches
      </p>
      {!hideImages && <ShefTrio shefs={shefs} className='flex justify-center gap-4 md:gap-8' />}
    </div>
  );
};
